import { CdkColumnDef } from '@angular/cdk/table';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatLegacyColumnDef as MatColumnDef,
  MatLegacyTable as MatTable,
} from '@angular/material/legacy-table';

import { TableDataSource } from '@shared/components/table/table-data-source.model';
import { required } from '@shared/decorators/required.decorator';
import { PageRequest } from '@shared/interfaces/page-request.interface';

@Component({
  selector: 'app-checkable-column',
  templateUrl: './checkable-column.component.html',
  styleUrls: ['./checkable-column.component.scss'],
})
export class CheckableColumnComponent<T> implements OnInit {
  dataSource!: TableDataSource<PageRequest, T>;
  @Input() @required tableRef!: MatTable<T>;
  @Input() hideCheckboxInHeader?: boolean;

  @ViewChild(MatColumnDef, { static: true }) checkboxColumn!: CdkColumnDef;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.dataSource = this.tableRef.dataSource as TableDataSource<
      PageRequest,
      T
    >;
    this.tableRef.addColumnDef(this.checkboxColumn);
    this.cdr.detectChanges();
  }
}
